// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BEpx","colBig":"styles_colBig__3yBH_","colSmall":"styles_colSmall__3sjnD"};